import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Alooma from 'services/alooma';
import useInitHotJar from 'services/useInitHotJar';
import useSetCjeInCookies from 'hooks/useSetCjeInCookies';
import useGoogleTagManager from 'hooks/useGoogleTagManager';
import { PATHS } from 'consts/paths';
import * as ALOOMA from 'consts/alooma';
import useProcessMarketingParamsOnPublicPage from 'hooks/useProcessMarketingParamsOnPublicPage';
import { Iframe } from './BlogPage.style';

const BlogPage = ({ location }) => {
  const pagePath = location.pathname.replace(/^\/blog/, '') || '';
  const pageSearch = location.search || '';

  useInitHotJar();
  useSetCjeInCookies();
  useGoogleTagManager();
  useProcessMarketingParamsOnPublicPage();
  Alooma.usePageViewTracker();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nocache" />
        <link rel="preconnect" href={PATHS.BLOG_ORIGINAL} />
      </Helmet>
      <Iframe
        title="Karma"
        src={`${PATHS.BLOG_ORIGINAL}${pagePath}${pageSearch}`}
        allow="identity-credentials-get"
        frameBorder="0"
      />
    </>
  );
};

export const BlogPageWithRoute = () => {
  return (
    <Switch>
      <Route
        path={[PATHS.BLOG]}
        render={props => (
          <Alooma.SourceContext.Provider value={ALOOMA.SOURCE_PAGES.BLOG}>
            <BlogPage {...props} />
          </Alooma.SourceContext.Provider>
        )}
      />
    </Switch>
  );
};
